<!--
  - Copyright (c) 2020. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
  -->

<template>
  <div class="columns">
    <div class="column is-12">
      <page-tile
        ratio="is-4by5"
        :to="{ name: ROUTE_NAMES.GARDEN_MAP, query: { plant: plant.id } }"
      >
        <template v-slot:title>
          <div
            v-if="!plant.name_lat"
            class="is-size-5-touch is-size-4 is-italic"
            style="opacity: 0;"
          >
            ...
          </div>
          <v-clamp
            autoresize
            :title="plant.name_lat"
            :max-lines="1"
            class="is-size-5-touch is-size-4 is-italic"
            >{{ plant.name_lat }}
          </v-clamp>
        </template>
        <template v-slot:subtitle>
          <div
            class="is-size-7-touch is-size-6"
            style="opacity: 0;"
            v-if="!plant.name"
          >
            ...
          </div>
          <v-clamp
            v-if="plant.name"
            autoresize
            :title="plant.name"
            :max-lines="1"
            class="is-size-7-touch is-size-6"
            >{{ plant.name }}
          </v-clamp>
        </template>
        <template v-slot:image>
          <img
            :src="getPlantImage(plant)"
            class="is-hoverable-image cover"
            :alt="$t('Blooming right now image')"
          />
        </template>
      </page-tile>
    </div>
  </div>
</template>
<script>
import VClamp from "vue-clamp";
import { ROUTE_NAMES } from "@/routes";
import PageTile from "./../../common/page-tile";

export default {
  data() {
    return {
      visible: false
    };
  },
  props: {
    plant: {
      type: Object,
      required: true
    },
    webp: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ROUTE_NAMES() {
      return ROUTE_NAMES;
    }
  },
  methods: {
    imageIsLandscape(img) {
      return (
        img.width && img.height && parseInt(img.width) > parseInt(img.height)
      );
    },
    getPlantImage(plant) {
      let idx = 0;
      for (idx in plant.images) break;
      if (plant.previewImages && plant.previewImages.length > 0) {
        idx = parseInt(plant.previewImages[0]);
      }
      if (plant.images && plant.images[idx]) {
        let url = plant.images[idx].url;
        let extension = ".png";
        if (this.webp) {
          extension = ".webp";
        }
        url = url.replace(".jpg", extension);
        url = url.replace(".jpeg", extension);
        url = url.replace(".png", extension);
        url = url.replace(".JPG", extension);
        url = url.replace(".JPEG", extension);
        url = url.replace(".PNG", extension);
        /*+
                      "/max-width/" +
                      this.getImagePreviewWidth(plant.images[idx]) +*/
        //this.webpPostfix;
        if (url.search("http://") === 0) {
          url = url.replace(/^http:\/\//, "https://");
        }
        return url;
      }
      return "";
    }
  },
  components: {
    VClamp,
    PageTile
  }
};
</script>
<style>
.cover {
  object-fit: cover;
}
</style>
